import api from './index';

export const gameAPI = {
  getChallenges: (params) => {
    return api.get('/api/game/challenges', { params });
  },
  submitChallenge: (data) => {
    return api.post('/api/game/challenges', data);
  },
  createChallenge: (data) => {
    return api.post('/api/game/challenges', data);
  },
  getGameStats: () => {
    return api.get('/api/game/stats');
  }
};